/**
 * Recording state.
 */
 import { make } from "vuex-pathify";
 import api from "@/api";
 
 const state = {
   maximumSize: 0,
   totalSize: 0
 };
 
 // automatically generate getters
 const getters = make.getters(state);
 
 const mutations = {
   ...make.mutations(state),
   // override
   setMaximumSize(state, maximumSize) {
     state.maximumSize = maximumSize;
   },
   setTotalSize(state, totalSize) {
    state.totalSize = totalSize;
  },
 };
 
 const actions = {
   ...make.actions(state),
 
   maximumSize({ commit }) {
     return new Promise(function(resolve) {
        api
        .get("Recordings/MaximumSize")
        .then(maximumSize => {
          commit("setMaximumSize", maximumSize);
          resolve(maximumSize);
        })       
     });
   },
   totalSize({ commit }) {
    return new Promise(function(resolve) {
       api
       .get("Recordings/TotalSize")
       .then(totalSize => {
         commit("setTotalSize", totalSize);
         resolve(totalSize);
       })       
    });
  },
 };
 
 export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions
 };
 